import Vue from 'vue';
window.Vue = Vue;

import VueToasted from 'vue-toasted';
import vueClipboard from 'vue-clipboard2';
import VueMask from 'v-mask'
import {Vuelidate} from 'vuelidate';
Vue.use(VueToasted);
Vue.use(vueClipboard);
Vue.use(VueMask);
Vue.use(Vuelidate);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// build longpress
// @see https://blog.logrocket.com/building-a-long-press-directive-in-vue-3408d60fb511/
/*
 * use v-longpress attribute to handle longpress (touch and mouse)
 * v-longpress="function-to-call-after-0.1s"
 * v-longpress:0,5="function-to-call-after-0.5s"
 *
 * the function will have several argument, the event, if it's a start or an end and the duration of press
 */
Vue.directive('longpress', {
	bind: function (el, binding, vNode)
	{
		// Make sure expression provided is a function
		if (typeof binding.value !== 'function')
		{
			// Fetch name of component
			const compName = vNode.context.name
			// pass warning to console
			let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`
			if (compName)
			{
				warn += `Found in component '${compName}' `
			}

			console.warn(warn)
		}

		let duration = binding.arg ? (new Number(binding.arg.replace(',', '.')) * 1000) : 100

		// Define variable
		let pressTimer = null

		// Define funtion handlers
		// Create timeout ( run function after 0.3s )
		let start = (e) => {
			if (e.type === 'click' && e.button !== 0)
			{
				return;
			}

			if (pressTimer === null)
			{
				pressTimer = setTimeout(() => {
					handler(e, true, duration)
				}, duration)
			}
		}

		// Cancel Timeout
		let cancel = (e) => {
			// Check if timer has a value or not
			if (pressTimer !== null)
			{
				clearTimeout(pressTimer)
				handler(e, false, pressTimer)
				pressTimer = null
			}
		}

		// Run Function
		const handler = (e, start) => {
			// Execute method that is passed to the directive
			binding.value(e, start)
		}

		// Add Event listeners
		el.addEventListener('mousedown', start);
		el.addEventListener('touchstart', start);

		// Cancel timeouts if this events happen
		el.addEventListener('click', cancel);
		el.addEventListener('mouseout', cancel);
		el.addEventListener('touchend', cancel);
		el.addEventListener('touchcancel', cancel);
	}
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
	el: '#app',
	delimiters: ['${', '}'],
	data: vue.data,
	mounted: vue.mounted,
	computed: vue.computed,
	methods: vue.methods,
	filters: vue.filters,
	watch: vue.watch
});

window.vm = app;
